import script from "./ChatPreviewLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatPreviewLoading.vue?vue&type=script&lang=ts&setup=true"

import "./ChatPreviewLoading.vue?vue&type=style&index=0&id=6dae8fe4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dae8fe4"]])

export default __exports__